export enum ApiRoute {
  CompanyInformation = '/companyInfo/getCompanyInfo',
  Login = '/login',
  SessionLogin = '/login/session-login',
  SwitchAccount = '/login/switchAccount',
  TwoFactorSendCode = '/twoFactor/send-code',
  TwoFactorVerify = '/twoFactor/verify',
  ForgotPassword = '/login/forgotPassword',
  Overview = '/overview',
  Portfolio = '/portfolio/getPortfolioData',
  PortfolioExport = '/portfolio/exportPortfolioData',
  InboxMessages = '/messages/getInboxMessages',
  SentMessages = '/messages/getSentMessages',
  SendMessage = '/messages/sendMessage',
  DeleteMessage = '/messages/deleteMessage',
  UpdateReadDateTime = '/messages/updateReadDateTime',
  UnreadMessageCount = '/messages/getUnreadMessageCount',
  LoanDetail = '/loanDetail/getLoanDetail',
  ResetPassword = '/passwordReset/resetPassword',
  SendResetPassword = '/passwordReset/sendForgotPassword',
  VerifyResetPassword = '/passwordReset/getIsValidResetId',
  Accounts = '/account/linked-accounts',
  UnlinkAccount = '/profile/deleteLinkedAccount',
  LinkAccount = '/profile/linkAccount',
  GetMatchingAccounts = '/profile/getMatchingAccounts',
  VerifyAndLinkAccount = '/profile/verifyAndLinkAccount',
  UpdatePassword = '/profile/updatePassword',
  GetAnnouncementStatus = '/profile/getAnnouncementStatus',
  SetAnnouncementHidden = '/profile/setAnnouncementHidden',
  Account = '/account/linked-accounts',
  History = '/loanhistory',
  AllHistoryGrouped = '/history/getAllHistory',
  HistoryLoanAccounts = '/history/getLoanAccounts',
  HistoryExport = '/loanhistory/exportHistoryData',
  Documents = '/documents/queryDocuments',
  RecentDocuments = '/documents/getRecentDocuments',
  RecentDocumentsCount = '/documents/getRecentDocumentsCount',
  DocumentDownload = '/documents/downloadDocument',
  DocumentYears = '/documents/getDocumentYears',
  UpcomingPayments = '/upcomingPayments/getUpcomingPayments',
  TrustAccount = '/trustAccount',
  RecentPayments = '/paymentsdetails/recent',
  LatestPaymentByAccount = '/paymentsdetails',
  ConventionalPaymentDetails = '/paymentsdetails/conventional',
  BillablePaymentDetails = '/paymentsdetails/billable',
  ARMPaymentDetails = '/paymentsdetails/arm',
  LOCPaymentDetails = '/paymentsdetails/loc',
  LastPaymentInfo = '/paymentsdetails/last-payment',
  SavedPayments = '/paymentsdetails/saved',
  ProcessPayment = 'payment/process-payment',
  GetConvenienceFeeNew = 'payment/getconveniencefee',
  CompanyPaymentProcessingFees = '/payment/getCompanyPaymentProcessingFees',
  ConstructionDrawRequestQuery = '/constructionDrawRequestQuery',
  ConstructionDrawRequestLoanProgress = '/constructionDrawRequestQuery/getLoanProgress',
  ConstructionDrawRequestBudgetedItems = '/constructionDrawRequestQuery/getBudgetedItems',
  ConstructionDrawRequestFeatureEnabled = '/constructionDrawRequestQuery/getIsDrawRequestFeatureEnabledAsync',
  ConstructionRequestDrawButtonEnabled = '/constructionDrawRequestQuery/getIsRequestDrawEnabled',
  ConstructionDrawRequestCreate = '/constructionDrawRequestCommand',
  ConstructionDrawRequestDelete = '/constructionDrawRequestCommand/delete',
  ConstructionDrawRequestCancel = '/constructionDrawRequestCommand/cancel',
  ConstructionDrawRequestUpdateBudgetedItems = '/constructionDrawRequestCommand/updateBudgetItems',
  ConstructionDrawRequestWithDetails = '/constructionDrawRequestQuery/getDrawRequestWithDetails',
  AttachmentList = '/borrowerAttachment/getAttachmentsListbyDrawRequest',
  AttachmentAdd = '/borrowerAttachment',
  AttachmentUpdate = '/borrowerAttachment/update',
  AttachmentDelete = '/borrowerAttachment/delete',
  BorrowerAttachmentUploadFile = '/borrowerAttachment/uploadFile',
  DrawRequestMessages = '/constructionDrawRequestMessage/GetMessages',
  DrawRequestSendMessage = '/constructionDrawRequestMessage/send',
  DrawRequestBulkSaveMessages = '/constructionDrawRequestMessage/bulkSave',
  DrawRequestMarkAsRead = '/constructionDrawRequestMessage/markAsRead',
  DrawRequestUnreadCount = '/constructionDrawRequestMessage/unreadCount',
  CustomPortalBanner = '/featureFlags/getCustomPortalBanner',
  PortalAnnouncement = '/portalAnnouncement/getPortalAnnouncement',
  CompanyTheme = '/companyTheme/getCompanyTheme',
  ChangeRequests = '/changeRequests',
}
